import image from './image.svg?inline'
import banner from './banner.svg?inline'
import article from './article.svg?inline'
import navBar from './navBar.svg?inline'
import notice from './notice.svg?inline'
import search from './search.svg?inline'
import video from './video.svg?inline'
import window from './window.svg?inline'
import goods from './goods.svg?inline'
import service from './service.svg?inline'
import guide from './guide.svg?inline'
import richText from './richText.svg?inline'
import blank from './blank.svg?inline'
import officialAccount from './officialAccount.svg?inline'
import coupon from './coupon.svg?inline'
import hotZone from './hotZone.svg?inline'
import special from './special.svg?inline'
import ICPLicense from './ICPLicense.svg?inline'
import title from './title.svg?inline'

export {
    image, banner, article, navBar, notice, search, video, window, goods, service,
    guide, richText, blank, officialAccount, coupon, hotZone,
    special, ICPLicense, title
}
